const VIBE_CODED_APPS_ROOT = '/vibe-coded-apps';

const route = (segment: string, title: string) => ({
  segment,
  title,
  path: segment ? `${VIBE_CODED_APPS_ROOT}/${segment}` : VIBE_CODED_APPS_ROOT,
  relativePath: segment ? `/${segment}` : '/',
});

export const VIBE_CODED_APPS_ROUTES = {
  root: route('', 'Internal Apps'),
  add: route('add', 'Add App'),
  // Platform-team page.
  admin: route('admin', 'App activity'),
  detail: route(':name', 'App detail'),
  update: route(':name/update', 'Update App'),
} as const;

/**
 * Static first segments (`add`, `admin`) outrank `:name`, so an app with one
 * of these names could never be opened from the list. The Add wizard refuses
 * them; this is the single source of that list.
 */
export const RESERVED_APP_NAMES: ReadonlySet<string> = new Set(
  Object.values(VIBE_CODED_APPS_ROUTES)
    .map(r => r.segment.split('/')[0])
    .filter(segment => segment && !segment.startsWith(':')),
);

export const isReservedAppName = (name: string) =>
  RESERVED_APP_NAMES.has(name.toLowerCase());

export const getVibeCodedAppPath = (name: string) =>
  VIBE_CODED_APPS_ROUTES.detail.path.replace(':name', encodeURIComponent(name));

export const VIBE_CODED_APPS_SUBMENU_ITEMS = [VIBE_CODED_APPS_ROUTES.add].map(
  ({ path: to, title }) => ({ title, to }),
);

/**
 * Header tabs shown to platform-team (`devprod`) members on the list and
 * App activity views, matching the BUI `<Header tabs={...}>` pattern used
 * across Backstage.
 */
export const VIBE_CODED_APPS_TABS = [
  {
    id: 'apps',
    label: 'Apps',
    href: VIBE_CODED_APPS_ROUTES.root.path,
  },
  {
    id: 'admin',
    label: VIBE_CODED_APPS_ROUTES.admin.title,
    href: VIBE_CODED_APPS_ROUTES.admin.path,
  },
] as const;
